import React, { useState, useEffect } from "react";
import TextField from "../../Components/common/TextField/TextField";
import { useDispatch, useSelector } from "react-redux";
import { licenceRegRequest } from "../../store/actions/usersActions";
import "./styles.scss";
import EyeIcon from "../../Components/Icon-SVG/EyeIcon";
import EyeCloseIcon from "../../Components/Icon-SVG/EyeCloseIcon";
import CopyIcon from "../../Components/Icon-SVG/CopyIcon";
import CopyButton from "../../Components/common/CopyButton/CopyButton";
import Hostname from "./Hostname";
import Unique from "./Unique";

// Long values (licence key, unique id) are shortened for display;
// the copy button always copies the full value
export const truncateValue = (value = "", maxLength = 40) =>
  value?.length > maxLength ? `${value.substring(0, maxLength)}...` : value || "";

export const maskValue = (value = "", maxLength = 40) =>
  "*".repeat(Math.min(value?.length || 0, maxLength));

const SystemInfo = () => {
  const dispatch = useDispatch();

  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const [licenceKey, setLicenceKey] = useState("");
  const [licenceInfo, setLicenceInfo] = useState([]);
  const [showKey, setShowKey] = useState(false);

  useEffect(() => {
    setLicenceKey("");
    setLicenceInfo(licenceCheck);
  }, [licenceCheck]);

  const sendKey = () => {
    dispatch(licenceRegRequest(licenceKey));
  };

  return (
    <div className="system-info">
      <div className="flex flex-align-items-center flex-justify-content-between">
        <h1>System Info</h1>
      </div>
      <div className="system-info__body">
        <div className="system-info__body-header">
          <div className="flex flex-align-items-center flex-justify-content-start flex-wrap">
            <h3>Licence</h3>
            <p className="analysis-images__description">
              <span> NOTE:</span> This section allows you to view and update system and license
              information.
            </p>
          </div>
        </div>
        {licenceInfo?.key && (
          <div className={`system-info__create flex-1`}>
            <table>
              <tbody>
                <tr>
                  <td>Key</td>
                  <td>
                    <div className="system-info__secret">
                      <span>:</span>
                      <span className="system-info__secret__text" title={licenceInfo?.key}>
                        {showKey ? truncateValue(licenceInfo?.key) : maskValue(licenceInfo?.key)}
                      </span>
                      {showKey && (
                        <span className="system-info__secret__action">
                          <CopyButton
                            title="Copy licence key"
                            itemToCopy={licenceInfo?.key}
                            icon={CopyIcon}
                            iconWidth={16}
                            iconHeight={16}
                            successMessage="Licence key copied"
                            failureMessage="Copy failed"
                          />
                        </span>
                      )}
                      <span
                        className="system-info__secret__action"
                        title={showKey ? "Hide key" : "Show key"}
                        onClick={() => setShowKey(!showKey)}>
                        {showKey ? <EyeCloseIcon /> : <EyeIcon />}
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>: {licenceInfo?.licenceStatus}</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>: {licenceInfo?.licenceDuration} Days</td>
                </tr>
                <tr>
                  <td>Licence Date</td>
                  <td>: {licenceInfo?.validFrom}</td>
                </tr>
                <tr>
                  <td>Expiration Date</td>
                  <td>: {licenceInfo?.validTo}</td>
                </tr>
                <tr>
                  <td>Integrations</td>
                  <td>
                    :{" "}
                    {licenceInfo?.integrations?.length === 1 &&
                    licenceInfo?.integrations[0] === "all"
                      ? "Enabled"
                      : licenceInfo?.integrations?.length === 0
                        ? "Disabled"
                        : licenceInfo?.integrations?.map(
                            (key, i) => " " + (i + 1) + " ) " + key + " ",
                          )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        <div className={`system-info__create flex-1`}>
          <h3>Add Licence Key</h3>
          <p className="label">Key</p>
          <div className="system-info__create__group">
            <TextField
              onChange={(e) => setLicenceKey(e.target.value)}
              value={licenceKey}
              placeholder={"Type Key"}
            />
            <div>
              <button onClick={() => sendKey()} className="primary-button">
                Add Key
              </button>
            </div>
          </div>
        </div>
        <Hostname />
        <Unique />
      </div>
    </div>
  );
};

export default SystemInfo;
